import { Home } from "lucide-react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-white flex items-center justify-center px-6">
      {/* Ambient gradient blobs */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 h-112 w-md rounded-full bg-sky-500/20 blur-3xl" />
        <div className="absolute top-1/3 -right-32 h-128 w-lg rounded-full bg-cyan-400/15 blur-3xl" />
        <div className="absolute -bottom-48 left-1/4 h-104 w-104 rounded-full bg-teal-400/10 blur-3xl" />
      </div>

      {/* Grid overlay */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative z-10 text-center">
        {/* Big 404 */}
        <h1 className="bg-linear-to-b from-white to-slate-400 bg-clip-text text-[8rem] font-bold leading-none tracking-tighter text-transparent sm:text-[10rem]">
          404
        </h1>

        <p className="mt-4 text-lg font-medium text-slate-200 sm:text-xl">
          This page wandered off the map.
        </p>
        <p className="mx-auto mt-3 max-w-md text-sm text-slate-400 sm:text-base">
          The page you're looking for doesn't exist or may have been moved.
          Let's get you back on track.
        </p>

        {/* Actions */}
        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          <Link
            to="/inventory"
            className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-sky-500/25 transition-colors hover:bg-sky-400"
          >
            <Home size={16} />
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
